import { css } from '@emotion/core';
var applyFont = _ref => {
  var family = _ref.family,
    size = _ref.size,
    lineHeight = _ref.lineHeight,
    weight = _ref.weight,
    textTransform = _ref.textTransform,
    style = _ref.style;
  return /*#__PURE__*/css("font-family:", family, ";font-size:", size, ";line-height:", lineHeight, ";font-weight:", weight, ";text-transform:", textTransform || 'none', ";font-style:", style, ";");
};
export default applyFont;